<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4pIT2U/tc-custom/9780830884438.jpg?1696024618772" alt="This image is the cover for the book Pocket Dictionary of the Reformed Tradition, The IVP Pocket Reference Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pocket Dictionary of the Reformed Tradition, The IVP Pocket Reference Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Beginning to study Reformed theology is like stepping into a family conversation that has been going on for five hundred years. How do you find your bearings and figure out how to take part in this conversation without embarrassing yourself?</p> <p>The <em>Pocket Dictionary of the Reformed Tradition</em> takes on this rich, boisterous and varied tradition in its broad contours, filling you in on its common affirmations as well as its family tensions. Here you will find succinct and reliable entries on</p>  Latin terms, such as <em>ad fontes</em> and <em>sola fide</em>  Theologians, from Calvin to Torrance Confessions, such as the Belgic and Westminster Doctrines, such as atonement and sanctification Apologists, such as Francis Schaeffer and Cornelius Van Til  <p>And much more.</p> <p>The <em>Pocket Dictionary of the Reformed Tradition</em> is ready to assist you over the rough parts of readings, lectures, conversations and blogs. It will also be a companionable and concise introduction to one of the great Christian traditions.</p> <p>Designed for students and pastors alike, the short and accessible volumes in the IVP Pocket Reference Series will help you tackle the study of biblical languages, church history, apologetics, world religions, Christian spirituality, ethics, theology, and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly M. Kapic, Wesley Vander Lugt
      </h2>
      
      <p class="authorDescription body article"><p>Kelly M. Kapic (PhD, King's College London) is professor of theological studies at Covenant College in Lookout Mountain, Georgia. He is the author or editor of numerous books including <em>A Little Book for New Theologians</em>, <em>God So Loved He Gave</em>, <em>Communion with God</em>, <em>Mapping Modern Theology</em>, <em>Sanctification</em>, and <em>Pocket Dictionary of the Reformed Tradition</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?076dde6d